/**
 * `/itemPublic/category` satırı: `name` (TR), `nameEn`, `nameFr`, …
 * @param {{ name?: string, nameEn?: string, nameFr?: string }} cat
 * @param {'tr' | 'en' | 'fr'} [uiLocale]
 */
export function getLocalizedCategoryName(cat, uiLocale) {
  if (!cat) return '';
  const tr = String(cat.name ?? '').trim();
  if (!uiLocale || uiLocale === 'tr') return tr;

  if (uiLocale === 'en') {
    const en = String(cat.nameEn ?? '').trim();
    return en || tr;
  }
  if (uiLocale === 'fr') {
    const fr = String(cat.nameFr ?? '').trim();
    return fr || tr;
  }
  return tr;
}
